module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-white-on-red-bde09eb3dd7439777df2bbd487e51bc1.svg";